module.exports = __webpack_public_path__ + "static/img/about_1bg.cbcd5d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_1bg.jpg
// module id = 4RyO
// module chunks = 1